export const testimonials = [
  {
    id: "t1",
    name: "小满不加糖",
    role: "上班族 · 吃瓜两年",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20portrait%20of%20a%20young%20Chinese%20woman%20with%20short%20hair%20smiling%20softly%2C%20clean%20beige%20studio%20background%2C%20natural%20light%2C%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=avatar-chigua-01&orientation=squarish",
    content:
      "之前随便加了几个群，不是冷清就是广告刷屏。按这里的排行挑了一个日更群，晚上还有「今日瓜回顾」，终于不用自己一个个爬楼找重点了。",
    rating: 5,
  },
  {
    id: "t2",
    name: "追剧的老周",
    role: "资深剧迷",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20portrait%20of%20a%20middle%20aged%20Chinese%20man%20with%20glasses%20and%20gentle%20smile%2C%20soft%20cream%20studio%20background%2C%20natural%20lighting%2C%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=avatar-chigua-02&orientation=squarish",
    content:
      "追剧群最怕剧透，这里的「追剧不孤单俱乐部」把剧透单独分区，边看边聊也不会被提前破坏体验，这点真的很贴心。",
    rating: 5,
  },
  {
    id: "t3",
    name: "阿黎Lily",
    role: "大学生",
    avatar:
      "https://readdy.ai/api/search-image?query=Cheerful%20portrait%20of%20a%20young%20Chinese%20college%20student%20girl%20with%20long%20hair%2C%20soft%20peach%20background%2C%20bright%20natural%20light%2C%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=avatar-chigua-03&orientation=squarish",
    content:
      "选群指南那篇我认真读完了，尤其是「先潜水三天再决定」这条，帮我避开了一个看起来热闹、其实全是营销号的群。",
    rating: 5,
  },
  {
    id: "t4",
    name: "老曹的观察笔记",
    role: "内容爱好者",
    avatar:
      "https://readdy.ai/api/search-image?query=Calm%20thoughtful%20portrait%20of%20a%20Chinese%20man%20in%20his%20thirties%20wearing%20a%20simple%20shirt%2C%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=avatar-chigua-04&orientation=squarish",
    content:
      "难得的是这里会把「待证实」的内容单独标出来，不跟着节奏跑。理性讨论群虽然更新慢一点，但每次看都能理清脉络。",
    rating: 4,
  },
];